import { Col, Row } from 'antd';
import { h2Bottom } from '../../assets';
import React from 'react';

const data = [
    {
        icon: `https://rapidevgames.com/wp-content/uploads/2020/02/A1.png`,
        h3: 'CUSTOMER FOCUS',
        pSmall: `We guarantee customer satisfaction by serving quality products reaching optimal efficiency and ensure best customer experience regarding all our services.`
    },
    {
        icon: `https://rapidevgames.com/wp-content/uploads/2020/02/a2.png`,
        h3: `QUALITY PRODUCTS`,
        pSmall: `Our brilliant and devotee software team have created quality product multiple time tested to assure its quality to meet customer’s satisfaction.`
    },
    {
        icon: `https://rapidevgames.com/wp-content/uploads/2020/02/a3.png`,
        h3: 'ON-TIME DELIVERY',
        pSmall: `Our talented and skilled developers make sure that the product should meet the deadline given by the client and to satisfy them.`
    },
    {
        icon: `https://rapidevgames.com/wp-content/uploads/2020/02/a4.png`,
        h3: 'PRIVACY',
        pSmall: `We promise to keep customer’s data secure and have high level privacy to acquire trust and respect factor in all our activities. `
    },

    {
        icon: `https://rapidevgames.com/wp-content/uploads/2020/02/a5.png`,
        h3: 'QUALITY SERVICES',
        pSmall: `Rapidev Games has expert and experienced team to deliver you managed team services of the product and serve you according to your needs and expectations.`
    },
    {
        icon: `https://rapidevgames.com/wp-content/uploads/2020/02/a6.png`,
        h3: 'APPROACH',
        pSmall: `Rapidev follows agile framework for software development which includes different phases of the project i.e. Analysis, Requirements gathering, design, implementation, quality assurance and deployment are the phases in the development of the project.`
    },
]
const App = () => {
    return (
        <div>
            <Row className='AboutServices' wrap align='middle' justify='space-between'>
                <Col span={24} style={{ display: "flex", flexDirection: "column", alignItems: "center", margin: "70px 0" }}>
                    <h2 style={{ margin: "0 auto 20px auto" }} >WHY RAPIDEV GAMES</h2>
                    <img src={h2Bottom} alt="img" />
                </Col>
                {
                    data.map((data, index) => {
                        return (

                            <Col
                                xs={{
                                    span: 24,
                                    offset: 1,
                                }}
                                md={24}
                                lg={{
                                    span: 11,
                                    offset: 2,
                                }}

                                key={index}
                            >
                                <p>{data?.icon ? <img src={data?.icon} alt='img' /> : "icon"}</p>
                                <h3>{data?.h3}</h3>
                                <p className='pSmall'>{data?.pSmall}</p>
                            </Col>
                        )
                    })
                }
            </Row>
        </div>
    )
}
export default App;